module.exports = __webpack_public_path__ + "img/couples-060.6a10827c.jpg";